const interval = [
  'Monthly',
  'Fortnightly',
  'Weekly'
]
const formatter = new Intl.NumberFormat('ir-IE', {
  style: 'currency',
  currency: 'EUR',
  // maximumSignificantDigits: 2,
})
const validateMinMax = (min, max, val) => {
  if (val < min) {
    val = min
  }
  if (val > max) {
    val = max
  }
  return val
}

const purposeDataDefault = {
  lp_id: '',
  lp_title: '',
  lp_amount_from: 0,
  lp_amount_to: 0,
  lp_amount_default: 0,
  lp_amount_step: 0,
  lp_apr: 0,
  lp_term_from: 0,
  lp_term_to: 0,
  lp_term_default: 0,
  lp_nominal_rate: 0,
  lp_excerpt: '',
  cl_mortgage: 0,
  cl_secured: 0,
  cl_private: 0
}

const parsePurposeData = (purposeData) => {
  return {
    lp_amount_from: parseInt(purposeData.lp_amount_from),
    lp_amount_to: parseInt(purposeData.lp_amount_to),
    lp_amount_default: parseInt(purposeData.lp_amount_default),
    lp_amount_step: parseInt(purposeData.lp_amount_step),
    lp_apr: parseFloat(purposeData.lp_apr),
    lp_term_from: parseInt(purposeData.lp_term_from),
    lp_term_to: parseInt(purposeData.lp_term_to),
    lp_term_default: parseInt(purposeData.lp_term_default),
    lp_nominal_rate: parseFloat(purposeData.lp_nominal_rate),
    lp_excerpt: purposeData.lp_excerpt,
    lp_id: purposeData.lp_id,
    lp_title: purposeData.lp_title,
    cl_mortgage: purposeData.cl_mortgage,
    cl_secured: purposeData.cl_secured,
    cl_private: purposeData.cl_private,
  }
}

const getPurposeId = (purposes, purpose) => {
  let id = 0
  if (purpose && purposes && purposes.length > 0) {
    purposes.forEach((el, index) => {
      const title = el['lp_title'].trim().toLowerCase()
      const titleFormated_1 = title.replace(/\s+/g, '_')
      const titleFormated_2 = title.replace(/\s+/g, '-')

      if (purpose === titleFormated_1 || purpose === titleFormated_2) {
        id = index
      }
    })
  }
  return id
}

const FormHelper = {
  Interval: interval,
  moneyFormatter: formatter,
  validateMinMax: validateMinMax,
  purposeDataDefault: purposeDataDefault,
  parsePurposeData: parsePurposeData,
  getPurposeId: getPurposeId,
}

export default FormHelper
